import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import LNG_MAP from './languages';

const SUPPORTED_LANGUAGES = Object.keys(LNG_MAP);
const SNAPSTORE_NAMESPACE_PATTERN = /^\/locales\/([a-z-]+)\/([a-z0-9_-]+)\.json$/i;
const DEFAULT_LANGUAGE = 'en';
const DEFAULT_NAMESPACES = ['common', 'seo', 'translation'];

const normalizeLanguage = (value) => {
  const normalizedLanguage = typeof value === 'string' ? value.toLowerCase().trim() : '';
  return SUPPORTED_LANGUAGES.includes(normalizedLanguage)
    ? normalizedLanguage
    : DEFAULT_LANGUAGE;
};

const getPathLanguage = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LANGUAGE;
  }

  const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
  return normalizeLanguage(firstSegment);
};

const getSnapStoreResources = () => {
  if (typeof window === 'undefined' || typeof window.snapStore !== 'object' || !window.snapStore) {
    return undefined;
  }

  const resources = {};
  const entries = Object.entries(window.snapStore);
  for (const [path, payload] of entries) {
    const match = SNAPSTORE_NAMESPACE_PATTERN.exec(path);
    if (!match || !payload || typeof payload !== 'object') {
      continue;
    }

    const locale = normalizeLanguage(match[1]);
    const namespace = match[2];
    if (!resources[locale]) {
      resources[locale] = {};
    }
    resources[locale][namespace] = payload;
  }

  return Object.keys(resources).length > 0 ? resources : undefined;
};

const snapStoreResources = getSnapStoreResources();
const initialLanguage = getPathLanguage();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    load: 'languageOnly',
    ns: DEFAULT_NAMESPACES,
    defaultNS: 'common',
    fallbackLng: DEFAULT_LANGUAGE,
    fallbackNS: 'common',
    resources: snapStoreResources,
    partialBundledLanguages: true,
    debug: false,
    lowerCaseLng: true,
    detection: {
      order: ['path', 'localStorage', 'sessionStorage', 'cookie'],
    },
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    supportedLngs: SUPPORTED_LANGUAGES,
  });

export default i18n;
